import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Trophy } from 'lucide-react';
import { Section } from './Shared';
const checkoutUrl = 'https://kit-saberes-ancestrales-argentinos.impultienda.ar/checkout/front';
export function Pricing() {
  return <Section id="pricing" className="bg-brand-surfaceLight/60 rounded-3xl my-12 border border-brand-purple/20" data-id="element-380" data-mp="2okjw9q9p1p8y">
      <div className="text-center mb-8" data-id="element-381" data-mp="1vtiah6bhwvgg">
        <div className="inline-flex items-center gap-2 rounded-full border border-brand-gold/50 bg-brand-goldLight/30 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-brand-goldDark md:text-sm" data-id="element-382" data-mp="1vujxm95sd8ej">
          <Trophy className="h-4 w-4" data-id="element-383" data-mp="25tj0fb3ve9tm" /> Oferta de lanzamiento
        </div>
        <h2 className="mt-4 text-2xl font-display font-bold text-brand-purpleDark md:text-4xl" data-id="element-384" data-mp="20sd4l4ewy6fv">
          UN SOLO KIT.
TODO RESUELTO.
        </h2>
        <p className="mt-3 text-sm text-brand-text/70 md:text-base" data-id="element-385" data-mp="3h97j3qa3cmom">
          4 tomos principales + 3 bonus estratégicos. Acceso inmediato y de por vida.
        </p>
      </div>

      <div className="mx-auto max-w-2xl rounded-3xl border-2 border-brand-purple bg-white p-6 text-center shadow-[0_0_28px_rgba(45,95,63,0.18)] md:p-9" data-id="element-386" data-mp="3vz6ydqddgbmb">
        <div className="mb-4 flex items-center justify-center gap-2 text-brand-purple" data-id="element-387" data-mp="9rz0180vd4zs">
          <Trophy className="h-5 w-5 fill-brand-purple" data-id="element-388" data-mp="erv6ddx1h8ii" />
          <span className="text-xs font-bold uppercase tracking-[0.16em] md:text-sm" data-id="element-389" data-mp="ep8yfd68kqzr">Kit completo</span>
        </div>
        <h3 className="font-serif text-xl font-bold leading-tight text-brand-purpleDark md:text-3xl" data-id="element-390" data-mp="3i81x6jucvb9v">
          KIT SABERES ANCESTRALES ARGENTINOS
        </h3>
        <p className="mt-2 text-sm text-brand-text/70 md:text-base" data-id="element-391" data-mp="3n5k98j3o66m3">
          4 Tomos + 3 Bonus · 385 páginas
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm font-medium leading-relaxed text-brand-purple md:text-base" data-id="element-392" data-mp="3rzy9ozx6v3xm">
          Dominá la fitoterapia nativa, las preparaciones profesionales, el criterio clínico y la espagiria vegetal argentina.
        </p>

        <div className="my-6 flex items-end justify-center gap-3" data-id="element-393" data-mp="2rg37sd7augs7">
          <span className="pb-1 text-base text-brand-text/40 line-through md:text-lg" data-id="element-394" data-mp="2mhrxk1d3e49g">$120.000</span>
          <span className="font-serif text-4xl font-bold leading-none text-brand-purple md:text-5xl" data-id="element-395" data-mp="316ekop8yo0b8">$27.990</span>
          <span className="pb-1 text-sm font-bold text-brand-purple md:text-base" data-id="element-396" data-mp="2w71ovf043iwi">ARS</span>
        </div>

        <div className="mx-auto mb-7 grid max-w-lg gap-2 text-left text-xs text-brand-text md:grid-cols-2 md:text-sm" data-id="element-397" data-mp="28h7c0xfsluc9">
          {['4 tomos clínicos incluidos', '3 bonus listos para imprimir', 'Acceso inmediato en PDF', 'Garantía total de 7 días'].map(item => <div key={item} className="flex items-center gap-2" data-id="element-398" data-mp="2dfilh726e2ty">
              <CheckCircle2 className="h-4 w-4 shrink-0 text-brand-purple" data-id="element-399" data-mp="3tutu8w9bpqf6" />
              {item}
            </div>)}
        </div>

        <motion.a href={checkoutUrl} animate={{
        scale: [1, 1.018, 1],
        y: [0, -2, 0]
      }} transition={{
        duration: 2.4,
        ease: 'easeInOut',
        repeat: Infinity
      }} whileHover={{
        scale: 1.035,
        y: -2
      }} whileTap={{
        scale: 0.98
      }} className="cta-shimmer purple-gradient-bg inline-flex w-full items-center justify-center rounded-full px-6 py-4 text-sm font-bold text-white shadow-[0_0_20px_rgba(45,95,63,0.4)] md:py-5 md:text-lg" data-id="element-400" data-mp="3ovz4facxv1lk">
          🏆 → QUIERO MI KIT COMPLETO $27.990
        </motion.a>
        <p className="pt-4 text-xs text-brand-text/60 md:text-sm" data-id="element-401" data-mp="o0hluq0yrf6b">
          🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro · 💳 Mercado Pago
        </p>
      </div>
    </Section>;
}